import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { HttpService } from "../shared/services/http.service";
import { ControllerService } from "../shared/services/controller.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { StoreHelper } from "../shared/helpers/store.helper";

@Component({
    selector: "app-action-report",
    templateUrl: "./action-report.component.html",
    styleUrls: ["./action-report.component.scss"],
    standalone: false
})
export class ActionReportComponent implements OnInit {
  reportData: any = []
  dataSource: any
  avgDataSource: any
  topDataSource: any

  clientId = -1;
  clientName = "";
  clientNameFull = '';
  tagId: string | null = null;
  super = false;

  showTip = true

  filterDebounce: any;

  displayedColumns = []
  avgDisplayedColumns = []
  topDisplayedColumns = []

  academicYears = []
  codes = []

  kind = ''

  code = ''
  academicYearFilter = null

  @ViewChild('actionsSort', { static: true }) sort: MatSort = new MatSort();
  @ViewChild('avgSort', { static: true }) avgSort: MatSort = new MatSort();


  @ViewChild("downloadReportButton", { static: false }) downloadReportButton;
  @ViewChild("hiddenDownloadReport", { static: false }) hiddenDownloadReport;

  totals: any = {};

  columnNames = [
    {
      id: "name",
      value: "Client Name",
    },
    {
      id: 'kind',
      value: 'Client Type'
    },
    {
      id: "description",
      value: "Code description",
    },
    {
      id: "action",
      value: "Action",
    },
    {
      id: "count",
      value: "User selections",
    },
    {
      id: "percentage",
      value: "% of users to select action",
    },
  ];


  avgColumnNames = [
    {
      id: "name",
      value: "Client Name",
    },
    {
      id:'kind',
      value: 'Client Type'
    },
    {
      id: "description",
      value: "Code Description",
    },
    {
      id: "average_count",
      value: "Average Number of Actions",
    },
  ]

  topColumnNames = [
    {
      id:'kind',
      value:'Kind'
    },
    {
      id:"rn",
      value: "Position"
    },
    {
      id:"title",
      value: "Action"
    }
  ]

  constructor(
    private httpService: HttpService,
    public controller: ControllerService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private router: Router
  ) {}

  goBack() {
    this.router.navigate([`client/${this.clientName}/report`]);
  }

  hideTip() {
    StoreHelper.setObject('hideActionsTip', true)
    this.showTip = false
  }

  async fetchCodes( ){

    const resp :any = await this.httpService.postAsync("report/allCodesForClient", {clientId: this.clientId})
    this.codes = resp.codes
  }

  async selectCode( event ){

    this.code = event.target.value || null

    await this.fetchReport(this.clientId)
  }

  async selectAcademicYear( event ){

    let year = event.target.value || null

    this.academicYearFilter = this.academicYears.find( yearObject => yearObject.formatted_year == year )


    await this.fetchReport(this.clientId)

  }

  async ngOnInit() {
    this.controller.shiftContainerToTop()

    this.super = this.controller.isSuper()

    this.showTip = StoreHelper.getObject('hideActionsTip') ? false : true

    await this.fetchAcademicYears()

    this.tagId = this.route.snapshot.queryParamMap.get('tagId');

    this.route.url.subscribe( async (url: Params) => {
      this.clientName = url[1].path
      this.clientId = this.controller.getClientId(url[1].path)
      if( this.clientName == '_ALL_' || this.tagId){
        this.clientId = 0
      }
      this.clientNameFull = this.controller.getClientName(this.clientId)

      this.displayedColumns = this.columnNames.map(x => x.id)
      if( this.clientId > 0 ){
        this.displayedColumns.splice(0,2)
      }

      await this.fetchCodes()


      this.topDisplayedColumns = this.topColumnNames.map(x => x.id)


      this.avgDisplayedColumns = this.avgColumnNames.map(x => x.id)
      if( this.clientId > 0 ){
        this.avgDisplayedColumns.splice(0,2)
        this.topDisplayedColumns.splice(0,1)
      }

      this.dataSource = new MatTableDataSource(this.reportData)
      this.dataSource.sort = this.sort;

      this.avgDataSource = new MatTableDataSource(this.reportData)
      this.avgDataSource.sort = this.avgSort


      this.topDataSource = new MatTableDataSource([])

      await this.fetchReport( this.clientId );

    })
  }

  async fetchAcademicYears(){

    const res:any = await this.httpService.postAsync("report/academicYears", {})

    this.academicYears = res.academicYears
  }



  async selectTypeFilter( event ){
    const k = event.target.value

    if( !k ){
      this.dataSource.data = this.reportData['actions']
      this.avgDataSource.data = this.reportData['averages']
      this.topDataSource.data = this.reportData['top5Client']

      return
    }

    this.kind = k

    await this.fetchReport( this.clientId )

  }


  loading = false
  skeletonRows: number[][] = [];
  skeletonRowsTop5: number[][] = [];

  generateSkeletonRows() {
    this.skeletonRows = Array(10).fill(0).map(() => {
      // Random number of bars between 5 and 8 to ensure density
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        // Random flex weight between 1 and 10 to give variety in width
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });

    this.skeletonRowsTop5 = Array(3).fill(0).map(() => {
        // Random number of bars for smaller table
        const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
        const bars = [];
        for (let i = 0; i < barCount; i++) {
          bars.push(Math.floor(Math.random() * 10) + 1);
        }
        return bars;
      });
  }


  async fetchReport( clientId ){

    this.loading = true
    this.generateSkeletonRows();

    // Clear data immediately to show skeleton
    this.dataSource.data = [];
    this.avgDataSource.data = [];
    this.topDataSource.data = [];

    try{
      // this.renderer.addClass(document.body, 'loading'); // Removing global loading

      // Wait for both the API call and at least 1 second
      const [reportData] = await Promise.all([
        this.httpService.postAsync("report/actions", {kind: this.kind, clientId, code: this.code, academicYear: this.academicYearFilter, tagId: this.tagId}),
        new Promise(resolve => setTimeout(resolve, 250))
      ]);

      this.reportData = reportData;

      // this.renderer.removeClass(document.body, 'loading'); // Removing global loading

    }catch(e){
      this.controller.redirectToSignIn()
    } finally {
      this.loading = false
    }

    this.dataSource.data =  this.reportData['actions']

    this.avgDataSource.data = this.reportData['averages']

    this.topDataSource.data = this.reportData['top5Client']


  }

  async downloadReport() {

    const clientId = this.clientId ? this.clientId : 0

    this.renderer.addClass(document.body, 'loading');

    const blob :any = await this.httpService.postBlob('report/downloadActions', {kind: this.kind, clientId, code: this.code, academicYear: this.academicYearFilter, tagId: this.tagId})

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${this.clientName}-actions.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    this.renderer.removeClass(document.body, 'loading');

    return false

}

  filter(event) {
    if (this.filterDebounce) {
      window.clearTimeout(this.filterDebounce);
    }

    this.filterDebounce = window.setTimeout(() => {
      this.dataSource.filter = event.target.value.trim();

    }, 250);
  }


}
